import { render, staticRenderFns } from "./Asistio.vue?vue&type=template&id=2aa8b2d2&"
import script from "./Asistio.vue?vue&type=script&lang=js&"
export * from "./Asistio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VForm,VSwitch})
